import script from "./site-wrapbox.vue?vue&type=script&lang=js"
export * from "./site-wrapbox.vue?vue&type=script&lang=js"

import "./site-wrapbox.vue?vue&type=style&index=0&id=17c55041&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/site-wrapbox.vue'],['__file',"site-wrapbox.vue"]])

export default __exports__